import { CategorySelection } from './components/CategorySelection';

export const StepTwo = () => <CategorySelection />;
